var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBookA = function SvgBookA(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/book"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66675 23.9998V9.33317C4.66675 3.99984 6.00008 2.6665 11.3334 2.6665H20.6667C26.0001 2.6665 27.3334 3.99984 27.3334 9.33317V22.6665C27.3334 22.8532 27.3334 23.0398 27.3201 23.2265",
    stroke: "#536DFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.46675 20H27.3334V24.6667C27.3334 27.24 25.2401 29.3333 22.6667 29.3333H9.33341C6.76008 29.3333 4.66675 27.24 4.66675 24.6667V23.8C4.66675 21.7067 6.37341 20 8.46675 20Z",
    stroke: "#536DFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M12.7758 16C12.5658 16 12.3932 15.9521 12.2582 15.8562C12.1306 15.7603 12.0481 15.6312 12.0106 15.4689C11.9806 15.3066 12.0143 15.1259 12.1119 14.9267L14.9928 8.71922C15.1128 8.46842 15.2554 8.28769 15.4204 8.17704C15.5855 8.05901 15.7768 8 15.9944 8C16.2119 8 16.4033 8.05901 16.5683 8.17704C16.7334 8.28769 16.8722 8.46842 16.9847 8.71922L19.8881 14.9267C19.9857 15.1259 20.0194 15.3103 19.9894 15.4799C19.9669 15.6422 19.8919 15.7713 19.7643 15.8672C19.6368 15.9557 19.4717 16 19.2692 16C19.0141 16 18.8153 15.941 18.6727 15.823C18.5377 15.7049 18.4177 15.5205 18.3126 15.2697L17.6374 13.7317L18.3351 14.2075H13.6424L14.3401 13.7317L13.6761 15.2697C13.5636 15.5279 13.4436 15.716 13.316 15.834C13.196 15.9447 13.0159 16 12.7758 16ZM15.9719 9.92531L14.5314 13.3001L14.2276 12.8686H17.7499L17.4461 13.3001L15.9944 9.92531H15.9719Z",
    fill: "#536DFE"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBookA);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "book-a.88e1f66cd7ed142bf7ad2f606f1056cc.svg";